import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IAllLeadsResponse, ILead, INewLead, ISingleLeadRespose } from "../models/Lead";
import apiConfig from "../utils/apiConfig";

export interface ILeadFilters {
  query: string;
  status?: number;
  awaitingCod?: boolean;
  includeCompleted?: boolean;
  showDropOff?: boolean;
  startDate?: Date | null;
  endDate?: Date | null;
  website?: number;
  pageFilter?: number;
  document?: number;
}

export default function useLeadsWithFilters(filters: ILeadFilters, componentName = "useLeadsWithFilters") {
  const { get, getFile, post, postGetFile, put, del } = useApiHelper(apiConfig(componentName));
  const queryClient = useQueryClient();

  const leadsWithFilters = useQuery({
    queryKey: ["leads", "filtered", filters.query, filters.status, filters.website, filters.pageFilter, filters.document, filters.awaitingCod, filters.includeCompleted, filters.showDropOff, filters.startDate, filters.endDate],
    //Don't try to put this on multiple lines, it breaks the search
    queryFn: () => get<IAllLeadsResponse>(`/lead/partialwithfilters?query=${filters.query}&leadstatus=${filters.status ?? 0}&websitefilter=${filters.website ?? 0}&pagefilter=${filters.pageFilter ?? 0}&documentfilter=${filters.document ?? 6}&awaitingcod=${filters.awaitingCod ?? false}&includeCompleted=${filters.includeCompleted ?? false}&showDropOff=${filters.showDropOff ?? false}&startDate=${filters.startDate ? filters.startDate.toISOString() : ""}&endDate=${filters.endDate ? filters.endDate.toISOString() : ""}`),
    staleTime: 1000 * 60 * 10, // 10 minutes
    // refetchInterval: 1000 * 60 * 1, // 1 minutes
    // refetchIntervalInBackground: true,
  });

  return {
    leadsWithFilters,
  };
}
